import React from "react";
import {ReactComponent as ArrowRight} from '../img/icons/arrow-r.svg';
import {Link} from "react-router-dom";

// import {BrowserRouter as Router, Link} from 'react-router-dom';


function ButtonLink({children}) {
  return (
    <button className="btn btn-arrow btn-border" ><span><p>{children}</p>
<ArrowRight/>
                    </span>
    </button>  
  );
}

export default ButtonLink;
